// Shared persona picker — most core screens are persona-scoped.
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function PersonaSelect({ value, onChange }) {
  const [personas, setPersonas] = useState([]);
  useEffect(() => {
    api.listPersonas().then((p) => {
      setPersonas(p);
      if (!value && p.length) onChange(p[0].id);
    }).catch(() => {});
  }, []); // eslint-disable-line

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-md bg-neutral-800 border border-neutral-700 px-3 py-2 text-sm"
    >
      <option value="">Selecione uma persona…</option>
      {personas.map((p) => (
        <option key={p.id} value={p.id}>{p.name}</option>
      ))}
    </select>
  );
}
